// extracted by mini-css-extract-plugin
export var container = "_eq-0";
export var content = "_eq-3";
export var customerTitle = "_eq-4";
export var empty = "_eq-5";
export var gray = "_eq-6";
export var header = "_eq-7";
export var info = "_eq-8";
export var loading = "_eq-2";
export var loadingCard = "_eq-9";
export var oneLine = "_eq-a";
export var personName = "_eq-e";
export var pillContainer = "_eq-b";
export var selected = "_eq-1";
export var text = "_eq-c";
export var twoLines = "_eq-d";
export var unread = "_eq-f";
export var unreadIndicator = "_eq-g";